import { render, staticRenderFns } from "./FunctionAccessGrid.vue?vue&type=template&id=5b34f5cb"
import script from "./FunctionAccessGrid.vue?vue&type=script&lang=js"
export * from "./FunctionAccessGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports